/**
 * useWeightBarcodePrefixes — ağırlık barkodu okurken kabul edilecek prefix'ler
 *
 * Tartı etiketi `prefix(2) + kod(5) + gram(5) + kontrol(1)` biçiminde. Prefix
 * cihaz ayarı olduğu için `Scales` tablosunda tartı başına duruyor: mağaza
 * fabrika ayarı 27'yi değiştirmiş ya da iki tartıyı farklı prefix'e almış
 * olabilir.
 *
 * Hiç tartı tanımlanmamışsa varsayılana düşer — kasada etiket okumak için
 * tartıyı GTS'e tanımlamak zorunlu değil.
 */

import { useEffect, useState } from 'react';
import scaleApi from '../services/scaleService';
import { DEFAULT_WEIGHT_BARCODE_PREFIX } from '../components/salesSystem/quickSale/utils/weightBarcode';

export function useWeightBarcodePrefixes(enabled: boolean | undefined): string[] {
  const [prefixes, setPrefixes] = useState<string[]>([DEFAULT_WEIGHT_BARCODE_PREFIX]);

  useEffect(() => {
    if (!enabled) return;

    let cancelled = false;

    scaleApi
      .getAll({ activeOnly: true })
      .then((scales) => {
        if (cancelled) return;
        const found = Array.from(
          new Set(
            scales
              .map((s) => (s.barcodePrefix || '').replace(/\D/g, ''))
              .filter((p) => p.length === 2)
          )
        );
        setPrefixes(found.length ? found : [DEFAULT_WEIGHT_BARCODE_PREFIX]);
      })
      .catch(() => {
        // Tartı listesi alınamazsa varsayılanla devam: etiket okuma çalışmaya
        // devam etsin, kasa API hatası yüzünden kilitlenmesin
        if (!cancelled) setPrefixes([DEFAULT_WEIGHT_BARCODE_PREFIX]);
      });

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return prefixes;
}

export default useWeightBarcodePrefixes;
